<template>
  <div class="profile-image-container">
    <div
      class="profile-image"
      :class="[
        sizeClass,
        { 'no-image': !effectiveSrc }
      ]"
    >
      <img
        v-if="effectiveSrc && !hasError"
        :src="effectiveSrc"
        :alt="alt"
        class="w-full h-full object-cover"
        @error="hasError = true"
      >
      <div
        v-else
        class="flex items-center justify-center w-full h-full"
      >
        <i class="pi pi-user text-4xl text-gray-400" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
  src: { type: String, default: '' },
  alt: { type: String, default: 'Profile' },
  size: { type: String, default: 'medium' }
});

const hasError = ref(false);

const effectiveSrc = computed(() => {
  const s = props.src;
  return (s && typeof s === 'string' && s.trim()) ? s.trim() : '';
});

const sizeClass = computed(() => {
  const s = props.size || 'medium';
  return `size-${s}`;
});

watch(() => props.src, () => {
  hasError.value = false;
});
</script>

<style scoped>
.profile-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-image {
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #e5e7eb;
  cursor: default;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-image.size-thumbnail {
  width: 100px;
  height: 100px;
}

.profile-image.size-small {
  width: 150px;
  height: 150px;
}

.profile-image.size-medium {
  width: 200px;
  height: 200px;
}

.profile-image.size-large {
  width: 500px;
  height: 500px;
}

.profile-image:hover {
  border-color: #3b82f6;
  transform: scale(1.05);
}

.profile-image.no-image {
  border-color: #d1d5db;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
}

.profile-image.no-image:hover {
  border-color: #9ca3af;
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
}
</style>
